import CopywritingInput from "./CopywritingInput";

export default CopywritingInput;
